import React from "react";
import PropTypes from 'prop-types'
import { Draggable } from "@hello-pangea/dnd";

// Style
import { 
  ItemContainer
} from "./PipelineItem.style"

const PipelineItem = ({
  item,
  index,
}) => {

  return (
    <Draggable draggableId={item.id} index={index} key={item.id}>
      {provided => {
        return (
          <ItemContainer 
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {item?.content}
          </ItemContainer>
        )}}
    </Draggable>
)}

PipelineItem.propTypes = {
  item: PropTypes.object,
}

PipelineItem.defaultProps = {
  item: {}
}

export default PipelineItem